import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";


const HandleSignUp = (props) => {
  const { instance } = useMsal();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSignup = async () => {
    try {
      // Sign up using MSAL
      const result = await props.msalInstance.loginPopup({
        scopes: ["openid", "profile", "email"],
        authority: "https://your-tenant.b2clogin.com/your-tenant.onmicrosoft.com/B2C_1_signupsignin1",
        loginHint: email,
        extraQueryParameters: {
          tfp: "B2C_1_signupsignin1",
        },
      });

      // Call  back-end API with sign-up information
      const response = await fetch("https://your-api-url", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: result.account.username,
          phone: result.account.idTokenClaims.phone_number,
        }),
      });

      const data = await response.json();

      // Handle response from back-end API
      console.log(data);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div>
      <input type="text" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
      <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
      <button onClick={handleSignup}>Sign up</button>
    </div>
  );
};

export default HandleSignUp;